require('./style.css');
var tmpl = require('./main.ejs');
var Events = require('f.core.event');

var PlayButton = function (url) {
  this.url = url;
  this.init();
};

PlayButton.prototype.init = function () {
  this.initDom();
  this.initEvent();
};

PlayButton.prototype.initDom = function () {
  var div = document.createElement('div');
  div.innerHTML = tmpl();
  this.el = div.children[0];
};

PlayButton.prototype.initEvent = function () {
  var clickFn = function (e) {
    this.trigger('click', e);
  }.bind(this);
  this.el.addEventListener('click', clickFn, false);
};

PlayButton.prototype.renderTo = function (parentNode) {
  parentNode.appendChild(this.el);
};

PlayButton.prototype.changeState = function (type) {
  var types = {
    'play': '',
    'pause': ' c-video__button--play',
    'replay': ' c-video__button--replay',
    'waiting': ' c-video__button--waiting'
  };
  this.el.className = 'c-video__button' + types[type];
  return this.el.className;
};

PlayButton.prototype.show = function () {
  this.el.style.visibility = 'visible';
};

PlayButton.prototype.hide = function () {
  this.el.style.visibility = 'hidden';
};

PlayButton.prototype.destory = function () {
  this.off();
  this.el.removeEventListener('click', clickFn);
  this.el.parentNode.removeChild(this.el);
};

Events.mixTo(PlayButton);

module.exports = PlayButton;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/playButton/index.js